function addClass(el, className) {
	if (el.classList) {
		el.classList.add(className);
	} else {
		var current = el.className, found = false;
		var all = current.split(' ');
		for (var i = 0; i < all.length, !found; i++) found = all[i] === className;
		if (!found) {
			if (current === '') el.className = className;
			else el.className += ' ' + className;
		}
	}
}

function removeClass(el, className) {
	if (el.classList)
	  el.classList.remove(className);
	else
	  el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

function switchClass(el, oldClassName, newClassName) {
	removeClass(el, oldClassName);
	addClass(el, newClassName);
}

export {
	addClass,
	removeClass,
	switchClass
};